import React, { Component } from 'react';
import { SelectField } from 'react-md';

export default class ProfileTopBar extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    render() {
        let outerStyle = {};
        if (!this.props.isScrollTop) {
            outerStyle.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.16), 0 3px 3px rgba(0, 0, 0, 0.23)';
        }

        return (
            <div className="profile-top-bar-outer" style={outerStyle}>
                {
                    this.props.mode === 'view' ?
                        <div className="profile-top-bar-menu-button material-icons" onClick={this.props.toggleNav}>menu</div>
                        :
                        <div className="profile-top-bar-menu-button material-icons" onClick={this.props.handleModeChange.bind(null, 'view')}>arrow_back</div>
                }
                <div className="profile-top-bar-title-container">Profile</div>
                <div className="profile-top-bar-flashmenu-button material-icons"></div>
            </div>
        );
    }
}
